import React from "react";

const linkLabels = {
  ebay: "eBay",
  facebookMarketplace: "Facebook Marketplace",
  etsy: "Etsy",
  amazon: "Amazon",
};

const StorefrontAbout = ({ config }) => {
  const entries = Object.entries(config.marketplaceLinks || {})
    .filter(([, value]) => Boolean(value))
    .map(([key, value]) => ({
      label: linkLabels[key] || key,
      url: value,
    }));

  return (
    <section className="storefront-about">
      <div className="storefront-about__content">
        <h2>About {config.displayName}</h2>
        <p>
          {config.displayName} listings are synchronized from external marketplaces. Pricing,
          availability, and fulfillment remain on the originating marketplace to preserve
          buyer protections.
        </p>
        {config.legalName ? (
          <p className="storefront-about__legal">Legal entity: {config.legalName}</p>
        ) : null}
      </div>
      {entries.length > 0 ? (
        <div className="storefront-about__links">
          <h3>Marketplace profiles</h3>
          <ul>
            {entries.map((entry) => (
              <li key={entry.url}>
                <a href={entry.url} target="_blank" rel="noreferrer">
                  {entry.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </section>
  );
};

export default StorefrontAbout;
